// extracted by mini-css-extract-plugin
export default {"form-items-2":"resetPassword_form-items-2__QhRBB"};